import type { ControlMessage, Hello } from "./control";
import { PROTOCOLS, SCHEMAS } from "./versions";

/** One canonical example of every control message (used by tests and fixture generation). */
export const SAMPLE_HELLO: Hello = {
  t: "hello",
  app: {
    version: "1.4.0",
    sha: "abc1234",
    origin: "https://codeshare.example",
    builtAt: 1760000000,
  },
  proto: { ...PROTOCOLS },
  schema: { ...SCHEMAS },
  caps: ["run:python", "run:javascript"],
  peer: { id: "peer-a", clientId: "client-a", name: "Ada", color: "mauve" },
  nonce: "bm9uY2Utbm9uY2Utbm9uY2U",
};

type SamplesByType = { [T in ControlMessage["t"]]: Extract<ControlMessage, { t: T }> };

export const SAMPLES: SamplesByType = {
  hello: SAMPLE_HELLO,
  auth: { t: "auth", proof: "cHJvb2YtcHJvb2YtcHJvb2Y" },
  "auth.ok": { t: "auth.ok" },
  ping: { t: "ping", ts: 1760000000123 },
  pong: { t: "pong", ts: 1760000000123 },
  profile: { t: "profile", name: "Ada L.", color: "teal" },
  bye: { t: "bye", reason: "leaving" },
};
